import { bool, func, number, shape, string } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import analytics, { events, trackUpgradeStarted } from '../../../../utils/analytics';
import OrderSummary from '../../SharedComponents/OrderSummary/OrderSummary';
import UpsellCTA from './UpsellCTA';
import * as classNames from './CustomizeSidebar.module.css';

const UPGRADE_CTA = 'Upgrade';

const CustomizeSidebar = (props) => {
  const {
    displayOrderSummary,
    getExtraChoiceCount,
    boxData,
    cartSum,
    userData,
    displayViewButton,
    displayUpsellCta,
    viewAll,
    toggleViewAll,
  } = props;
  const buttonCTA = !viewAll ? 'View All' : 'View Less';

  return (
    <div className={classNames.summaryDetails}>
      {displayOrderSummary && (
        <OrderSummary
          title="Extra Choices"
          total={getExtraChoiceCount(boxData)}
          sum={cartSum}
          country={userData.shippingCountry ?? null}
          endDate={boxData.season.customizeEndDate}
          footnote="Total does not reflect credit applied."
        />
      )}
      {displayViewButton && (
        <Button
          width="100%"
          style={{ margin: '12px 0 0' }}
          onClick={() => {
            toggleViewAll();
            analytics.track(events.CLICKED_ELEMENT, {
              element_name: buttonCTA,
              option_title: 'Customizations',
            });
          }}
        >
          {buttonCTA}
        </Button>
      )}
      {displayUpsellCta && (
        <UpsellCTA
          title="Ready for exclusive perks?"
          description="Upgrade now to save $15 per box and get early access each season."
          ctaLabel={UPGRADE_CTA}
          onClick={() => {
            trackUpgradeStarted(UPGRADE_CTA);
          }}
        />
      )}
    </div>
  );
};

CustomizeSidebar.propTypes = {
  displayOrderSummary: bool.isRequired,
  getExtraChoiceCount: func.isRequired,
  boxData: shape({
    season: shape({
      customizeEndDate: string.isRequired,
    }).isRequired,
  }).isRequired,
  cartSum: number.isRequired,
  userData: shape({
    shippingCountry: string,
  }).isRequired,
  displayViewButton: bool.isRequired,
  displayUpsellCta: bool.isRequired,
  viewAll: bool.isRequired,
  toggleViewAll: func.isRequired,
};

export default CustomizeSidebar;
